document.addEventListener('turbolinks:load', () => {
  setupFacetFeedbackActions();
  setupQuickFacetSubmissionActions();
  setupHelpContentActions();
});

const setupFacetFeedbackActions = () => {
  const sliders = document.querySelectorAll('.wcs-range-slider');

  if (!sliders) return;

  sliders.forEach((slider) => {
    const handleSliderChange = (event) => {
      const sliderValue = event.target.value;
      const textField = document.getElementById(`text-field-container-${slider.id}`);
      const facetDetails = document.getElementById(`facet-details-${slider.id}`);

      if (sliderValue < 0) {
        if (!textField.classList.contains('invisible')) return;
        textField.classList.remove('opacity-0', 'invisible', 'pointer-events-none', 'h-0');
        textField.classList.add('opacity-100', 'h-full');
        textField.focus();

        facetDetails.classList.remove('opacity-100', 'flex-grow');
        facetDetails.classList.add('opacity-0', 'invisible', 'h-0');

        setTimeout(() => {
          facetDetails.classList.add('invisible');
        }, 500); // Match the duration of the fade-out transition
      } else {
        if (!facetDetails.classList.contains('invisible')) return;

        textField.blur();
        textField.classList.remove('opacity-100', 'h-full');
        textField.classList.add('opacity-0', 'pointer-events-none', 'h-0');
        
        setTimeout(() => {
          textField.classList.add('invisible');
          facetDetails.classList.remove('opacity-0', 'invisible', 'h-0');
          facetDetails.classList.add('opacity-100', 'flex-grow');
        }, 500); // Match the duration of the fade-out transition
      }
    };

    slider.addEventListener('change', handleSliderChange);
  });
}

const setupQuickFacetSubmissionActions = () => {
  const modal = document.getElementById('climateModal');
  const triggers = document.querySelectorAll('#climateStats, #statsTap');

  triggers.forEach(trigger => {
    trigger?.addEventListener('click', (event) => {
      event.stopPropagation(); // Prevents the click from reaching document
      openModal();
    });
  });

  if (modal) openModal();

  const sliders = document.querySelectorAll('.climate-range-slider');
  if (!sliders) return;

  sliders.forEach((slider) => {
    slider.addEventListener('input', () => {
      toggleCommentField(slider);
    });

    // Allow skipping the comment field
    const sliderContainer = slider.closest('.slider-container');
    const commentField = sliderContainer.querySelector(".climate-comment-field");
    const leaveCommentLink = sliderContainer.querySelector('.leave-comment-link');
    const skipLink = commentField.querySelector('#skipComment');

    skipLink.addEventListener('click', () => {
      hideCommentField(sliderContainer);
      if (slider.value < 0) {
        showLeaveCommentLink(sliderContainer);
      } else {
        hideLeaveCommentLink(sliderContainer);
      }
    });
    leaveCommentLink.addEventListener('click', () => {
      showCommentField(sliderContainer);
      hideLeaveCommentLink(sliderContainer);
    });

    // When reflecting negative value on initial load, display the leave comment link
    if (slider.value < 0) showLeaveCommentLink(sliderContainer);
  });

  const submitButton = document.getElementById('climateSubmitButton');
  const intro = document.querySelector('.climate-intro');
  const outro = document.querySelector('.climate-outro');
  const statsOutro = document.querySelector('.stats-outro');
  const audio = document.getElementById('sent');

  if (!submitButton || !intro || !outro || !statsOutro) { return; }

  audio.volume = 0.4;

  submitButton.addEventListener('click', () => {
    audio.play();
    closeModal();
    intro.classList.add('hidden');
    outro.classList.remove('hidden');
    statsOutro.classList.remove('hidden');
  });
};

const setupHelpContentActions = () => {
  const helpButton = document.querySelector('.help-button');
  const slidersContainer = document.querySelector('.sliders-container');
  const submitButton = document.getElementById('climateSubmitButton');
  const modal = document.getElementById('climateModal');

  if (!helpButton || !slidersContainer || !submitButton || !modal) return;

  let originalContent = null;
  let originalButton = null;
  let cachedHelpContent = null;
  let savedState = null;

  // Attach skip comment listeners
  const attachSkipCommentListeners = () => {
    document.querySelectorAll('#skipComment').forEach(skip => {
      const slider = skip.closest('.slider-container');
      const commentField = slider?.querySelector('.climate-comment-field');
      const leaveCommentLink = slider?.querySelector('.leave-comment-link');

      if (!commentField || !leaveCommentLink) return;

      skip.addEventListener('click', () => {
        commentField.classList.add('h-0', 'opacity-0', 'overflow-hidden');
        leaveCommentLink.classList.remove('hidden');
      });
    });
  };

  const getModalState = (modal) => {
    const state = {};
  
    // Capture all input/select/textarea values
    modal.querySelectorAll('input, textarea, select').forEach(input => {
      const key = input.name || input.id;
      if (key) {
        state[key] = input.value;
      }
    });
  
    // Capture visibility of each comment field
    modal.querySelectorAll('.slider-container').forEach(slider => {
      const sliderId = slider.querySelector('.climate-range-slider')?.id;
      const commentField = slider.querySelector('.climate-comment-field');
      if (sliderId && commentField) {
        const isVisible = !commentField.classList.contains('h-0');
        state[`visible:${sliderId}`] = isVisible;
      }
    });
  
    return state;
  };

  const restoreModalState = (modal, state) => {
    // Restore values of all inputs
    modal.querySelectorAll('input, textarea, select').forEach(input => {
      const key = input.name || input.id;
      if (key && key in state) {
        input.value = state[key];
      }
    });
  
    // Restore visibility of comment fields and reattach skip button behavior
    modal.querySelectorAll('.slider-container').forEach(slider => {
      const sliderId = slider.querySelector('.climate-range-slider')?.id;
      const commentField = slider.querySelector('.climate-comment-field');
      const leaveCommentLink = slider.querySelector('.leave-comment-link');
      const skipButton = slider.querySelector('#skipComment');
  
      if (!sliderId || !commentField || !leaveCommentLink) return;
  
      const isVisible = !!state[`visible:${sliderId}`];
  
      commentField.classList.toggle('h-0', !isVisible);
      commentField.classList.toggle('opacity-0', !isVisible);
      commentField.classList.toggle('overflow-hidden', !isVisible);
      leaveCommentLink.classList.toggle('hidden', isVisible);
  
      if (skipButton) {
        skipButton.addEventListener('click', () => {
          commentField.classList.add('h-0', 'opacity-0', 'overflow-hidden');
          leaveCommentLink.classList.remove('hidden');
        });
      }
    });
  };

  const handleHelpClick = async () => {
    const currentSubmitButton = document.getElementById('climateSubmitButton');
    if (!currentSubmitButton) return;

    // Store original content if not already stored
    if (!originalContent) {
      originalContent = slidersContainer.innerHTML;
      originalButton = currentSubmitButton.outerHTML;
    }

    savedState = getModalState(modal);

    try {
      if (!cachedHelpContent) {
        const helpUrl = modal.dataset.helpContentUrlValue;
        const response = await fetch(helpUrl);
        cachedHelpContent = await response.text();
      }

      // Measure help content height
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.visibility = 'hidden';
      tempDiv.style.width = `${slidersContainer.clientWidth}px`;
      tempDiv.innerHTML = `
        <div class="flex items-center relative">
          <h2 class="uppercase text-gray-900 font-bold w-full text-center">Work Climate Help</h2>
        </div>
        <div class="text-left overflow-auto">${cachedHelpContent}</div>
      `;
      document.body.appendChild(tempDiv);
      const helpContentHeight = tempDiv.scrollHeight;
      document.body.removeChild(tempDiv);

      // Set initial height before transition
      slidersContainer.style.height = `${slidersContainer.scrollHeight}px`;
      slidersContainer.style.overflow = 'hidden';

      // Force reflow to apply the transition properly
      slidersContainer.offsetHeight;

      // Apply transition properties
      slidersContainer.classList.add('transition-all', 'duration-500', 'ease-out');

      // Set target height BEFORE updating content
      slidersContainer.style.height = `${helpContentHeight}px`;

      // Wait a small time before updating content
      setTimeout(() => {
        slidersContainer.innerHTML = `
          <div class="flex items-center relative">
            <h2 class="uppercase text-gray-900 font-bold w-full text-center">Work Climate Help</h2>
          </div>
          <div class="text-left overflow-auto">${cachedHelpContent}</div>
        `;
        slidersContainer.style.overflow = 'auto';
      }, 10);

      // Replace submit button with close button
      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = currentSubmitButton.className;
      closeButton.id = 'closeHelpButton';
      closeButton.textContent = 'Close';

      closeButton.addEventListener('click', () => {
        // Measure original content height
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.visibility = 'hidden';
        tempDiv.style.width = `${slidersContainer.clientWidth}px`;
        tempDiv.innerHTML = originalContent;
        document.body.appendChild(tempDiv);
        const originalHeight = tempDiv.scrollHeight;
        document.body.removeChild(tempDiv);

        // Lock current height before transition
        slidersContainer.style.height = `${slidersContainer.scrollHeight}px`;

        // Force reflow
        slidersContainer.offsetHeight;

        // Apply transition and target height
        slidersContainer.classList.remove('ease-out');
        slidersContainer.classList.add('ease-in');
        slidersContainer.style.height = `${originalHeight}px`;

        // Restore content after the height transition
        setTimeout(() => {
          slidersContainer.innerHTML = originalContent;
          closeButton.outerHTML = originalButton;

          requestAnimationFrame(() => {
            const newModal = document.getElementById('climateModal');
            restoreModalState(newModal, savedState);

            // Re-trigger input event on all sliders to reapply gradient thumb color
            newModal.querySelectorAll('.climate-range-slider').forEach(slider => {
              slider.dispatchEvent(new Event('input', { bubbles: true }));
            });

            // Reattach help button event
            const newHelpButton = document.querySelector('.help-button');
            if (newHelpButton) {
              newHelpButton.addEventListener('click', handleHelpClick);
            }

            setupQuickFacetSubmissionActions();
            attachSkipCommentListeners();

            // Reset styles
            slidersContainer.style.height = '';
            slidersContainer.style.overflow = '';
            slidersContainer.classList.remove('transition-all', 'duration-500', 'ease-in', 'ease-out');
          });
        }, 500);
      });

      currentSubmitButton.replaceWith(closeButton);

      // Cleanup after expansion animation
      setTimeout(() => {
        slidersContainer.style.height = '';
      }, 500);
    } catch (error) {
      console.error('Error loading help content:', error);
    }
  };

  helpButton.addEventListener('click', handleHelpClick);
};

// Define animation classes
const sliderDelays = [
  "delay-[100ms]", "delay-[200ms]", "delay-[300ms]", "delay-[400ms]",
  "delay-[150ms]", "delay-[75ms]", "delay-[100ms]", "delay-[200ms]"
];
const modalEntering = ["opacity-100", "pointer-events-auto"];
const modalLeaving = ["opacity-0", "scale-y-75", "pointer-events-none"];
const statsEntering = ["opacity-100", "scale-y-100", "translate-y-0", "pointer-events-auto"];
const statsLeaving = ["opacity-0", "scale-y-[200%]", "translate-y-0", "pointer-events-none"];
const sliderHidden = ["opacity-30", "scale-50", "translate-y-2"];
const sliderVisible = ["opacity-100", "scale-100", "translate-y-0"];
const originalBodyOverflow = document.body.style.overflow;

// Helper function to toggle classes
const toggleClasses = (element, addClasses, removeClasses) => {
  element.classList.add(...addClasses);
  element.classList.remove(...removeClasses);
};

const openModal = () => {
  const modal = document.getElementById("climateModal");
  const stats = document.getElementById("climateStats");
  const sliders = modal?.querySelectorAll(".slider-container");

  toggleClasses(modal, modalEntering, modalLeaving);
  toggleClasses(stats, statsLeaving, statsEntering);

  sliders.forEach((slider, index) => {
    toggleClasses(slider, [...sliderVisible, sliderDelays[index]], sliderHidden);
  });

  // Prevent page scroll when modal is open.
  document.body.style.overflow = "hidden";
};

const closeModal = () => {
  const modal = document.getElementById("climateModal");
  const stats = document.getElementById("climateStats");
  const sliders = modal?.querySelectorAll(".slider-container");

  toggleClasses(modal, modalLeaving, modalEntering);
  toggleClasses(stats, statsEntering, statsLeaving);

  sliders.forEach((slider, index) => {
    toggleClasses(slider, sliderHidden, [...sliderVisible, sliderDelays[index]]);

    // Update stat indicators
    const value = parseInt(slider.querySelector(".climate-range-slider").value, 10);
    const name = slider.querySelector(".climate-range-slider").name;
    updateStatIndicator(name, value);
  });

  // Restore scrolling
  document.body.style.overflow = originalBodyOverflow;
};

const updateStatIndicator = (name, value) => {
  const stats = document.getElementById("climateStats");
  const facetName = name.match(/\[(.*?)\]/)[1].toLowerCase().replace(" ", "_");

  const indicator = stats.querySelector(`.${facetName} > .stat-indicator`);
  const leftFade = stats.querySelector(`.${facetName} > .stat-fades > .left-fade`);
  const rightFade = stats.querySelector(`.${facetName} > .stat-fades > .right-fade`);

  if (!indicator) return; // Prevent errors if element isn't found

  const parentWidth = indicator.parentElement.offsetWidth;
  const halfWidth = (indicator.offsetWidth / 2) / parentWidth;

  // Normalize value from -50 to 50 → 0 to 100
  let left = ((value + 50) / 100) * 100 - (halfWidth * 100);

  // Clamp values between 0 and 100
  left = Math.max(0, Math.min(left, 100 - (halfWidth * 2 * 100)));

  indicator.style.left = `${left}%`;
  indicator.style.background = colorForValue(value);
  leftFade.style.right = `${100 - left}%`;
  rightFade.style.left = `${left}%`;
};

const interpolateColor = (start, end, factor) => 
  start.map((channel, i) => Math.round(channel + (end[i] - channel) * factor));

const colorForValue = (value) => {
  const startRGB = [252, 26, 26];   // Red (-50)
  const middleRGB = [80, 96, 238];  // Blue (0)
  const endRGB = [18, 206, 25];     // Green (50)

  // Normalize value from -50 to 50 → 0 to 1
  let normalizedValue = Math.max(0, Math.min((value + 50) / 100, 1));

  const rgb = normalizedValue < 0.5
    ? interpolateColor(startRGB, middleRGB, normalizedValue * 2) // Red -> Blue
    : interpolateColor(middleRGB, endRGB, (normalizedValue - 0.5) * 2); // Blue -> Green

  return `rgb(${rgb.join(", ")})`;
};

const closeModalOnClickOutside = (event) => {
  const modal = document.getElementById("climateModal");
  if (modal && !modal.contains(event.target) && !modal.classList.contains("opacity-0")) {
    closeModal();
  }
};

let timeoutId;
const toggleCommentField = (slider) => {
  clearTimeout(timeoutId);

  timeoutId = setTimeout(() => {
    const sliderContainer = slider.closest(".slider-container");
    const commentField = sliderContainer.querySelector(".climate-comment-field");
    const value = parseInt(slider.value, 10);

    if (value < 0 && commentField.classList.contains("opacity-0")) {
      showCommentField(sliderContainer);
    } else if (value >= 0 && !commentField.classList.contains("opacity-0")) {
      hideCommentField(sliderContainer);
    }

    // We always hide the leave comment link when toggling the comment field.
    // Because if the score is negative, we show the comment field.
    // If the score is positive, we don't allow the user to leave a comment.
    hideLeaveCommentLink(sliderContainer);
  }, 150); // Delay to allow the slider to stop moving before triggering
};

const hideCommentField = (sliderContainer) => {
  const commentField = sliderContainer.querySelector(".climate-comment-field");

  setTimeout(function () {
    commentField.classList.add("opacity-0", "h-0", "overflow-hidden");
    commentField.classList.remove("opacity-100", "h-auto");
  }, 100);
};

const showCommentField = (sliderContainer) => {
  const commentField = sliderContainer.querySelector(".climate-comment-field");

  setTimeout(function () {
    commentField.classList.add("opacity-100", "h-auto");
    commentField.classList.remove("h-0", "opacity-0", "overflow-hidden");
  }, 100);
};

const showLeaveCommentLink = (sliderContainer) => {
  const leaveCommentLink = sliderContainer.querySelector('.leave-comment-link');

  setTimeout(function () {
    leaveCommentLink.classList.add("opacity-100", "h-auto");
    leaveCommentLink.classList.remove("h-0", "opacity-0", "overflow-hidden");
  }, 100);
};

const hideLeaveCommentLink = (sliderContainer) => {
  const leaveCommentLink = sliderContainer.querySelector('.leave-comment-link');

  setTimeout(function () {
    leaveCommentLink.classList.add("opacity-0", "h-0", "overflow-hidden");
    leaveCommentLink.classList.remove("opacity-100", "h-auto");
  }, 100);
};
